import React from "react";
import { ProgressSpinner } from 'primereact/progressspinner';

export default function Loader() {
    return <div className="loader flex justify-content-center">
        <ProgressSpinner/>
    </div>;
}   